import { render, staticRenderFns } from "./TagDisplay.vue?vue&type=template&id=f879fbd4&scoped=true&lang=html&"
import script from "./TagDisplay.vue?vue&type=script&lang=js&"
export * from "./TagDisplay.vue?vue&type=script&lang=js&"
import style0 from "./TagDisplay.vue?vue&type=style&index=0&id=f879fbd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f879fbd4",
  null
  
)

export default component.exports